<script setup>
definePage({ meta: { title: 'Edit Product', pageTitle: 'Edit Product' } })
</script>

<template>
  <VCard>
    <VCardTitle>Edit Product</VCardTitle>
    <VCardText>
      <p>Product editing functionality coming soon.</p>
    </VCardText>
  </VCard>
</template>
